import TokenService from '@/helpers/token';
import store from '@/store';
import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';

const baseUrl = process.env.VUE_APP_API_URL;
const options = {
    baseURL: baseUrl,
    headers: {},
};
if (TokenService.getToken() !== null) {
    options.headers = TokenService.getHeader();
}
const axiosInstance = axios.create(options);
axiosInstance.interceptors.request.use(async (request: AxiosRequestConfig) => {
    Object.assign(request?.headers, {
        Authorization: !!TokenService.getToken()
            ? `Bearer ${TokenService.getToken()}`
            : '',
        'X-LANG': TokenService.getLang() || 'vi',
    });
    return request;
});
axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
        response.data.success = response?.data?.status_code === 200;
        let fe_version = process.env?.VUE_APP_VERSION?.toString() || 'default'
        if(fe_version !== localStorage.getItem('fe-version') && response.config.method == 'get'){
            // window.navigator.serviceWorker.getRegistrations()
            //     .then(registrations => {
            //         for(let registration of registrations) {
            //             registration.unregister();
            //         }
            //     });
            var res = false;
            if (window.caches != null) {
                caches.keys().then(cacheNames => {
                    cacheNames.forEach(cacheName => {
                        caches.delete(cacheName).then(function(response) {
                            res = true;
                        });
                    });
                });
            }
            localStorage.clear()
            localStorage.setItem('fe-version', fe_version)
            window.location.reload() // For new version, simply reload on any get
        }
        return response?.data; // simply return the response's data
    },
    async (error) => {
        if (error.response) {
            error.response.data = {
                ...(error?.response?.data || {}),
                success: false,
            };
            return error.response?.data; // simply return the response's data
        } else if (error.request) {
            error.request.data = {
                ...(error?.request?.data || {}),
                success: false,
                isRequestError: true,
                message: error.message,
            };
            return error.request?.data;
        }
    },
);

export default axiosInstance;
